const CategoryBlocks = ({ data, selected, onToggle }) => {
  return (
    <div
      className="grid gap-2 mt-2"
      style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))', display: 'grid' }}
    >
      {data.map(item => {
        const isSelected = selected.some((i) => i.id === item.id);
        const isDisabled = item.jobCount === 0;
          return (
          <div 
            key={item.id}
            onClick={() => {
              if (!isDisabled) {
                onToggle('categories', item);
              }
            }}
            className={`bg-gray-800 cursor-pointer rounded-xl overflow-hidden shadow-md relative 
                  ${isSelected ? 'border border-teal-500' : 'border border-transparent'}
                  ${!isDisabled ? 'cursor-pointer hover:shadow-lg' : 'opacity-40 cursor-not-allowed hidden md:block'}`}
          >
            <div
              className="flex items-center justify-center h-16"
              style={{
                backgroundColor: `${hexToRgba(item.color, 0.2)}`
              }}
            >
              <div className="text-3xl">{item.icon}</div>
              {isSelected && (
                <div className="absolute top-2 left-2 w-5 h-5 bg-teal-500 text-black rounded-full flex items-center justify-center text-xs font-bold">
                  ✓
                </div>
              )}
            </div>

            {/* Ligne de séparation */}
            <div
              style={{
                height: '2px',
                backgroundColor: item.color
              }}
            />

            {/* Partie basse fixe */}
            <div className="bg-gray-800 p-4 text-white">
              <h3 className="font-semibold text-sm mb-1">{item.label}</h3>
              <p className="text-xs text-gray-300">{item.jobCount} métier{item.jobCount > 1 ? 's' : ''}</p>
            </div>
          </div>
        )
      })}
    </div>
  );
};

// ✅ Helper : convertir HEX + opacité RGBA
const hexToRgba = (hex, alpha = 1) => {
  const bigint = parseInt(hex.replace('#', ''), 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r},${g},${b},${alpha})`;
};
  
  export default CategoryBlocks;
  